import { TypeStatus } from '@/lib/api/playbackService/types';
import { TypeKeyValuePair } from '@/core/generated-types';

export function getCourseStatusDisplayText(
  courseStatus: TypeStatus,
  statusDisplayCopy: TypeKeyValuePair[],
) {
  const courseStatusDisplayCopyIdx = statusDisplayCopy.findIndex(
    (statusMapping) => statusMapping.fields.title === courseStatus,
  );

  if (
    courseStatusDisplayCopyIdx !== -1 &&
    statusDisplayCopy[courseStatusDisplayCopyIdx].fields.value.content[0]
      .content
  ) {
    return statusDisplayCopy[courseStatusDisplayCopyIdx].fields.value.content[0]
      .content[0].value;
  }

  return courseStatus;
}
